
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire49a6"];
var parcelRegister = parcelRequire.register;
parcelRegister("jed23", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");

var $zTYoH = parcelRequire("zTYoH");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.modalManager = module.exports.Modal = module.exports["default"] = void 0;

var $dff96f0fbeff3804$var$_possibleConstructorReturn2 = $l4FIw((parcelRequire("35on9")));

var $dff96f0fbeff3804$var$_getPrototypeOf3 = $l4FIw((parcelRequire("8yP2g")));

var $dff96f0fbeff3804$var$_assertThisInitialized2 = $l4FIw((parcelRequire("i4RG1")));

var $dff96f0fbeff3804$var$_inherits2 = $l4FIw((parcelRequire("eGfZt")));

var $dff96f0fbeff3804$var$_extends2 = $l4FIw((parcelRequire("5WrMC")));

var $dff96f0fbeff3804$var$_defineProperty2 = $l4FIw((parcelRequire("jIgr0")));

var $dff96f0fbeff3804$var$_objectWithoutProperties2 = $l4FIw((parcelRequire("ib1Q9")));

var $dff96f0fbeff3804$var$_classCallCheck2 = $l4FIw((parcelRequire("amPRp")));

var $dff96f0fbeff3804$var$_createClass2 = $l4FIw((parcelRequire("5pBBk")));

var $dff96f0fbeff3804$var$_autobindDecorator = $l4FIw((parcelRequire("8RfMd")));

var $dff96f0fbeff3804$var$_Modal = $l4FIw((parcelRequire("3SBlA")));

var $8lubB = parcelRequire("8lubB");

var $dff96f0fbeff3804$var$_classnames = $l4FIw((parcelRequire("g3elz")));

var $dff96f0fbeff3804$var$_closest = $l4FIw((parcelRequire("gBQ6d")));

var $dff96f0fbeff3804$var$_filterDOMProps = $l4FIw((parcelRequire("8ktw3")));

var $dff96f0fbeff3804$var$_ModalManager = $l4FIw((parcelRequire("e0JA4")));

var $dff96f0fbeff3804$var$_OpenTransition = $l4FIw((parcelRequire("cviGh")));

var $dff96f0fbeff3804$var$_PortalContainer = $l4FIw((parcelRequire("geIu6")));

var $dff96f0fbeff3804$var$_react = $zTYoH((parcelRequire("7eprg")));

var $dff96f0fbeff3804$var$_reactDom = $l4FIw((parcelRequire("5hg2n")));
var $dff96f0fbeff3804$var$_class, $dff96f0fbeff3804$var$_temp;
function $dff96f0fbeff3804$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $dff96f0fbeff3804$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $dff96f0fbeff3804$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $dff96f0fbeff3804$var$_defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $dff96f0fbeff3804$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var $dff96f0fbeff3804$var$MODAL_LIFECYCLE_METHODS = [
    "onBackdropClick",
    "onEnter",
    "onEntering",
    "onEntered",
    "onEscapeKeyDown",
    "onExit",
    "onExiting",
    "onExited",
    "onHide",
    "onShow"
];
var $dff96f0fbeff3804$var$MANAGER_SINGLETON = new $dff96f0fbeff3804$var$_ModalManager["default"]({
    handleContainerOverflow: false
});
module.exports.modalManager = $dff96f0fbeff3804$var$MANAGER_SINGLETON;
var $dff96f0fbeff3804$var$MODAL_KEY = 1;
var $dff96f0fbeff3804$var$ModalContainer = /*#__PURE__*/ function() {
    function ModalContainer() {
        (0, $dff96f0fbeff3804$var$_classCallCheck2["default"])(this, ModalContainer);
    }
    (0, $dff96f0fbeff3804$var$_createClass2["default"])(ModalContainer, null, [
        {
            key: "show",
            value: function show(content, context, container) {
                var key = $dff96f0fbeff3804$var$MODAL_KEY++; // If container is not specified, look for the provider of context
                if (!container && context) container = function container() {
                    return (0, $dff96f0fbeff3804$var$_closest["default"])($dff96f0fbeff3804$var$_reactDom["default"].findDOMNode(context), ".react-spectrum-provider");
                };
                else if (!container) container = function container() {
                    return document.querySelector(".react-spectrum-provider") || document.body;
                };
                var _content$props = content.props, disableEscKey = _content$props.disableEscKey, role = _content$props.role, onClose = _content$props.onClose, onHide = _content$props.onHide, onExited = _content$props.onExited, modalProps = (0, $dff96f0fbeff3804$var$_objectWithoutProperties2["default"])(_content$props, [
                    "disableEscKey",
                    "role",
                    "onClose",
                    "onHide",
                    "onExited"
                ]);
                role = role && role.indexOf("dialog") !== -1 ? "presentation" : "dialog"; // filter out content.props that are not modal lifecycle methods
                modalProps = $dff96f0fbeff3804$var$MODAL_LIFECYCLE_METHODS.reduce(function(obj, key) {
                    return $dff96f0fbeff3804$var$_objectSpread({}, obj, (0, $dff96f0fbeff3804$var$_defineProperty2["default"])({}, key, modalProps[key]));
                }, {});
                var modal = $dff96f0fbeff3804$var$_react["default"].createElement($dff96f0fbeff3804$var$Modal, (0, $dff96f0fbeff3804$var$_extends2["default"])({}, modalProps, {
                    container: container,
                    key: key,
                    keyboard: !disableEscKey,
                    role: role,
                    onClose: onClose,
                    onHide: (0, $8lubB.chain)(this.hide.bind(this, key), onHide, onExited)
                }), content);
                $dff96f0fbeff3804$var$_PortalContainer["default"].add(modal, context);
                return key;
            }
        },
        {
            key: "hide",
            value: function hide(key) {
                $dff96f0fbeff3804$var$_PortalContainer["default"].remove({
                    key: key
                });
            }
        }
    ]);
    return ModalContainer;
}();
module.exports["default"] = $dff96f0fbeff3804$var$ModalContainer;
var $dff96f0fbeff3804$var$Modal = (0, $dff96f0fbeff3804$var$_autobindDecorator["default"])($dff96f0fbeff3804$var$_class = ($dff96f0fbeff3804$var$_temp = /*#__PURE__*/ function(_React$Component) {
    (0, $dff96f0fbeff3804$var$_inherits2["default"])(Modal, _React$Component);
    function Modal() {
        var _getPrototypeOf2;
        var _this;
        (0, $dff96f0fbeff3804$var$_classCallCheck2["default"])(this, Modal);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, $dff96f0fbeff3804$var$_possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, $dff96f0fbeff3804$var$_getPrototypeOf3["default"])(Modal)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        (0, $dff96f0fbeff3804$var$_defineProperty2["default"])((0, $dff96f0fbeff3804$var$_assertThisInitialized2["default"])(_this), "state", {
            show: true
        });
        return _this;
    }
    (0, $dff96f0fbeff3804$var$_createClass2["default"])(Modal, [
        {
            key: "onClose",
            value: function onClose() {
                this.setState({
                    show: false
                });
                if (this.props.onClose) this.props.onClose();
            }
        },
        {
            key: "onEntering",
            value: function onEntering(e) {
                var _this2 = this;
                if (this.props.onEntering) this.props.onEntering(e);
                cancelAnimationFrame(this._autoFocusRAF);
                this._autoFocusRAF = requestAnimationFrame(function() {
                    // Make sure that autoFocus actually moves focus to the Modal
                    if (_this2.baseModal && _this2.baseModal.dialog) {
                        var dialogNode = $dff96f0fbeff3804$var$_reactDom["default"].findDOMNode(_this2.baseModal.dialog);
                        if (dialogNode !== document.activeElement || dialogNode && !dialogNode.contains(document.activeElement)) _this2.baseModal.autoFocus();
                        clearTimeout(_this2._autoFocusTimeout); // Safari on iOS does not move the VoiceOver cursor to the dialog
                        // or announce that it has opened until it has rendered. A workaround
                        // is to wait for half a second, then blur and re-focus the dialog.
                        _this2._autoFocusTimeout = setTimeout(function() {
                            if (document.activeElement === dialogNode) {
                                dialogNode.blur();
                                dialogNode.focus();
                            }
                        }, 500);
                    }
                });
            }
        },
        {
            key: "backdropMode",
            value: function backdropMode() {
                /*
       * backdropClickable (bc)
       *     bc | !bc
       *     ---|------
       *      t |static
       * if fullscreenTakeover, then always false
       */ var _this$props$children$ = this.props.children.props, backdropClickable = _this$props$children$.backdropClickable, mode = _this$props$children$.mode;
                var backdrop = "static";
                if (backdropClickable) backdrop = true;
                if (mode === "fullscreenTakeover") backdrop = false;
                return backdrop;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var backdrop = this.backdropMode();
                var _this$props = this.props, children = _this$props.children, onHide = _this$props.onHide, modalProps = (0, $dff96f0fbeff3804$var$_objectWithoutProperties2["default"])(_this$props, [
                    "children",
                    "onHide"
                ]); // The z-index here should match the one in Overlay
                return $dff96f0fbeff3804$var$_react["default"].createElement($dff96f0fbeff3804$var$_Modal["default"], (0, $dff96f0fbeff3804$var$_extends2["default"])({}, modalProps, {
                    style: {
                        zIndex: 100000,
                        position: "relative"
                    },
                    show: this.state.show,
                    ref: function ref(baseModal) {
                        return _this3.baseModal = baseModal;
                    },
                    onEntering: this.onEntering,
                    onExited: onHide,
                    onHide: this.onClose,
                    backdrop: backdrop,
                    manager: $dff96f0fbeff3804$var$MANAGER_SINGLETON,
                    renderBackdrop: function renderBackdrop(props) {
                        return $dff96f0fbeff3804$var$_react["default"].createElement($dff96f0fbeff3804$var$Underlay, props);
                    },
                    transition: $dff96f0fbeff3804$var$_OpenTransition["default"],
                    backdropTransition: $dff96f0fbeff3804$var$_OpenTransition["default"]
                }), (0, $dff96f0fbeff3804$var$_react.cloneElement)(children, {
                    onClose: this.onClose
                }));
            }
        }
    ]);
    return Modal;
}($dff96f0fbeff3804$var$_react["default"].Component), $dff96f0fbeff3804$var$_temp)) || $dff96f0fbeff3804$var$_class;
module.exports.Modal = $dff96f0fbeff3804$var$Modal;
var $dff96f0fbeff3804$var$Underlay = /*#__PURE__*/ function(_React$Component2) {
    (0, $dff96f0fbeff3804$var$_inherits2["default"])(Underlay, _React$Component2);
    function Underlay() {
        (0, $dff96f0fbeff3804$var$_classCallCheck2["default"])(this, Underlay);
        return (0, $dff96f0fbeff3804$var$_possibleConstructorReturn2["default"])(this, (0, $dff96f0fbeff3804$var$_getPrototypeOf3["default"])(Underlay).apply(this, arguments));
    }
    (0, $dff96f0fbeff3804$var$_createClass2["default"])(Underlay, [
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, open = _this$props2.open, props = (0, $dff96f0fbeff3804$var$_objectWithoutProperties2["default"])(_this$props2, [
                    "open"
                ]);
                return $dff96f0fbeff3804$var$_react["default"].createElement("div", (0, $dff96f0fbeff3804$var$_extends2["default"])({}, (0, $dff96f0fbeff3804$var$_filterDOMProps["default"])(props), {
                    className: (0, $dff96f0fbeff3804$var$_classnames["default"])("spectrum-Underlay", {
                        "is-open": open
                    })
                }));
            }
        }
    ]);
    return Underlay;
}($dff96f0fbeff3804$var$_react["default"].Component);

});
parcelRegister("3SBlA", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $2d33629e68b8dae6$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $dFcpi = parcelRequire("dFcpi");
var $2d33629e68b8dae6$var$_activeElement2 = $2d33629e68b8dae6$var$_interopRequireDefault($dFcpi);

var $7Zt2N = parcelRequire("7Zt2N");
var $2d33629e68b8dae6$var$_contains2 = $2d33629e68b8dae6$var$_interopRequireDefault($7Zt2N);

var $iDur4 = parcelRequire("iDur4");
var $2d33629e68b8dae6$var$_inDOM2 = $2d33629e68b8dae6$var$_interopRequireDefault($iDur4);

var $h4kRK = parcelRequire("h4kRK");
var $2d33629e68b8dae6$var$_propTypes2 = $2d33629e68b8dae6$var$_interopRequireDefault($h4kRK);

var $7c3Xh = parcelRequire("7c3Xh");
var $2d33629e68b8dae6$var$_componentOrElement2 = $2d33629e68b8dae6$var$_interopRequireDefault($7c3Xh);

var $hQop9 = parcelRequire("hQop9");
var $2d33629e68b8dae6$var$_deprecated2 = $2d33629e68b8dae6$var$_interopRequireDefault($hQop9);

var $dZHUK = parcelRequire("dZHUK");
var $2d33629e68b8dae6$var$_elementType2 = $2d33629e68b8dae6$var$_interopRequireDefault($dZHUK);

var $7eprg = parcelRequire("7eprg");
var $2d33629e68b8dae6$var$_react2 = $2d33629e68b8dae6$var$_interopRequireDefault($7eprg);

var $5hg2n = parcelRequire("5hg2n");
var $2d33629e68b8dae6$var$_reactDom2 = $2d33629e68b8dae6$var$_interopRequireDefault($5hg2n);

var $boanT = parcelRequire("boanT");
var $2d33629e68b8dae6$var$_warning2 = $2d33629e68b8dae6$var$_interopRequireDefault($boanT);

var $3vuoS = parcelRequire("3vuoS");
var $2d33629e68b8dae6$var$_ModalManager2 = $2d33629e68b8dae6$var$_interopRequireDefault($3vuoS);

var $kkZS4 = parcelRequire("kkZS4");
var $2d33629e68b8dae6$var$_Portal2 = $2d33629e68b8dae6$var$_interopRequireDefault($kkZS4);

var $1FFBs = parcelRequire("1FFBs");
var $2d33629e68b8dae6$var$_RefHolder2 = $2d33629e68b8dae6$var$_interopRequireDefault($1FFBs);

var $cSIz2 = parcelRequire("cSIz2");
var $2d33629e68b8dae6$var$_addEventListener2 = $2d33629e68b8dae6$var$_interopRequireDefault($cSIz2);

var $9haex = parcelRequire("9haex");
var $2d33629e68b8dae6$var$_addFocusListener2 = $2d33629e68b8dae6$var$_interopRequireDefault($9haex);

var $aK5Rh = parcelRequire("aK5Rh");
var $2d33629e68b8dae6$var$_getContainer2 = $2d33629e68b8dae6$var$_interopRequireDefault($aK5Rh);

var $bi5EL = parcelRequire("bi5EL");
var $2d33629e68b8dae6$var$_ownerDocument2 = $2d33629e68b8dae6$var$_interopRequireDefault($bi5EL);
function $2d33629e68b8dae6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2d33629e68b8dae6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2d33629e68b8dae6$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $2d33629e68b8dae6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint-disable react/prop-types */ 
var $2d33629e68b8dae6$var$modalManager = new $2d33629e68b8dae6$var$_ModalManager2.default();
/**
 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
 * The Modal component renders its `children` node in front of a backdrop component.
 *
 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
 *
 * - Manages dialog stacking when one-at-a-time just isn't enough.
 * - Creates a backdrop, for disabling interaction below the modal.
 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
 * - It disables scrolling of the page content while open.
 * - Adds the appropriate ARIA roles are automatically.
 * - Easily pluggable animations via a `<Transition/>` component.
 *
 * Note that, in the same way the backdrop element prevents users from clicking or interacting
 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
 * interact with page content while the Modal is open. To do this, we use a common technique of applying
 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
 * React hierarchy (such as the default: document.body).
 */ var $2d33629e68b8dae6$var$Modal = function(_React$Component) {
    $2d33629e68b8dae6$var$_inherits(Modal, _React$Component);
    function Modal() {
        var _temp, _this, _ret;
        $2d33629e68b8dae6$var$_classCallCheck(this, Modal);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $2d33629e68b8dae6$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), $2d33629e68b8dae6$var$_initialiseProps.call(_this), _temp), $2d33629e68b8dae6$var$_possibleConstructorReturn(_this, _ret);
    }
    Modal.prototype.omitProps = function omitProps(props, propTypes) {
        var keys = Object.keys(props);
        var newProps = {};
        keys.map(function(prop) {
            if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) newProps[prop] = props[prop];
        });
        return newProps;
    };
    Modal.prototype.render = function render() {
        var _props = this.props, show = _props.show, container = _props.container, children = _props.children, Transition = _props.transition, backdrop = _props.backdrop, className = _props.className, style = _props.style, onExit = _props.onExit, onExiting = _props.onExiting, onEnter = _props.onEnter, onEntering = _props.onEntering, onEntered = _props.onEntered;
        var dialog = $2d33629e68b8dae6$var$_react2.default.Children.only(children);
        var filteredProps = this.omitProps(this.props, Modal.propTypes);
        var mountModal = show || Transition && !this.state.exited;
        if (!mountModal) return null;
        var _dialog$props = dialog.props, role = _dialog$props.role, tabIndex = _dialog$props.tabIndex;
        if (role === undefined || tabIndex === undefined) dialog = (0, $7eprg.cloneElement)(dialog, {
            role: role === undefined ? "document" : role,
            tabIndex: tabIndex == null ? "-1" : tabIndex
        });
        if (Transition) dialog = $2d33629e68b8dae6$var$_react2.default.createElement(Transition, {
            appear: true,
            unmountOnExit: true,
            "in": show,
            onExit: onExit,
            onExiting: onExiting,
            onExited: this.handleHidden,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered
        }, dialog);
        return $2d33629e68b8dae6$var$_react2.default.createElement($2d33629e68b8dae6$var$_Portal2.default, {
            ref: this.setMountNode,
            container: container,
            onRendered: this.onPortalRendered
        }, $2d33629e68b8dae6$var$_react2.default.createElement("div", $2d33629e68b8dae6$var$_extends({
            ref: this.setModalNodeRef,
            role: role || "dialog"
        }, filteredProps, {
            style: style,
            className: className
        }), backdrop && this.renderBackdrop(), $2d33629e68b8dae6$var$_react2.default.createElement($2d33629e68b8dae6$var$_RefHolder2.default, {
            ref: this.setDialogRef
        }, dialog)));
    };
    Modal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (nextProps.show) this.setState({
            exited: false
        });
        else if (!nextProps.transition) // Otherwise let handleHidden take care of marking exited.
        this.setState({
            exited: true
        });
    };
    Modal.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
        if (!this.props.show && nextProps.show) this.checkForFocus();
    };
    Modal.prototype.componentDidMount = function componentDidMount() {
        this._isMounted = true;
        if (this.props.show) this.onShow();
    };
    Modal.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        var transition = this.props.transition;
        if (prevProps.show && !this.props.show && !transition) // Otherwise handleHidden will call this.
        this.onHide();
        else if (!prevProps.show && this.props.show) this.onShow();
    };
    Modal.prototype.componentWillUnmount = function componentWillUnmount() {
        var _props2 = this.props, show = _props2.show, transition = _props2.transition;
        this._isMounted = false;
        if (show || transition && !this.state.exited) this.onHide();
    };
    Modal.prototype.autoFocus = function autoFocus() {
        if (!this.props.autoFocus) return;
        var dialogElement = this.getDialogElement();
        var currentActiveElement = (0, $2d33629e68b8dae6$var$_activeElement2.default)((0, $2d33629e68b8dae6$var$_ownerDocument2.default)(this));
        if (dialogElement && !(0, $2d33629e68b8dae6$var$_contains2.default)(dialogElement, currentActiveElement)) {
            this.lastFocus = currentActiveElement;
            if (!dialogElement.hasAttribute("tabIndex")) {
                (0, $2d33629e68b8dae6$var$_warning2.default)(false, 'The modal content node does not accept focus. For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".');
                dialogElement.setAttribute("tabIndex", -1);
            }
            dialogElement.focus();
        }
    };
    Modal.prototype.restoreLastFocus = function restoreLastFocus() {
        // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
        if (this.lastFocus && this.lastFocus.focus) {
            this.lastFocus.focus();
            this.lastFocus = null;
        }
    };
    Modal.prototype.getDialogElement = function getDialogElement() {
        return $2d33629e68b8dae6$var$_reactDom2.default.findDOMNode(this.dialog);
    };
    Modal.prototype.isTopModal = function isTopModal() {
        return this.props.manager.isTopModal(this);
    };
    return Modal;
}($2d33629e68b8dae6$var$_react2.default.Component);
$2d33629e68b8dae6$var$Modal.propTypes = $2d33629e68b8dae6$var$_extends({}, $2d33629e68b8dae6$var$_Portal2.default.propTypes, {
    /**
   * Set the visibility of the Modal
   */ show: $2d33629e68b8dae6$var$_propTypes2.default.bool,
    /**
   * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
   *
   * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
   * page content can be placed behind a virtual backdrop as well as a visual one.
   */ container: $2d33629e68b8dae6$var$_propTypes2.default.oneOfType([
        $2d33629e68b8dae6$var$_componentOrElement2.default,
        $2d33629e68b8dae6$var$_propTypes2.default.func
    ]),
    /**
   * A callback fired when the Modal is opening.
   */ onShow: $2d33629e68b8dae6$var$_propTypes2.default.func,
    /**
   * A callback fired when either the backdrop is clicked, or the escape key is pressed.
   *
   * The `onHide` callback only signals intent from the Modal,
   * you must actually set the `show` prop to `false` for the Modal to close.
   */ onHide: $2d33629e68b8dae6$var$_propTypes2.default.func,
    /**
   * Include a backdrop component.
   */ backdrop: $2d33629e68b8dae6$var$_propTypes2.default.oneOfType([
        $2d33629e68b8dae6$var$_propTypes2.default.bool,
        $2d33629e68b8dae6$var$_propTypes2.default.oneOf([
            "static"
        ])
    ]),
    /**
   * A function that returns a backdrop component. Useful for custom
   * backdrop rendering.
   *
   * ```js
   *  renderBackdrop={props => <MyBackdrop {...props} />}
   * ```
   */ renderBackdrop: $2d33629e68b8dae6$var$_propTypes2.default.func,
    /**
   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
   */ onEscapeKeyDown: $2d33629e68b8dae6$var$_propTypes2.default.func,
    /**
   * Support for this function will be deprecated. Please use `onEscapeKeyDown` instead
   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
   * @deprecated
   */ onEscapeKeyUp: (0, $2d33629e68b8dae6$var$_deprecated2.default)($2d33629e68b8dae6$var$_propTypes2.default.func, "Please use onEscapeKeyDown instead for consistency"),
    /**
   * A callback fired when the backdrop, if specified, is clicked.
   */ onBackdropClick: $2d33629e68b8dae6$var$_propTypes2.default.func,
    /**
   * A style object for the backdrop component.
   */ backdropStyle: $2d33629e68b8dae6$var$_propTypes2.default.object,
    /**
   * A css class or classes for the backdrop component.
   */ backdropClassName: $2d33629e68b8dae6$var$_propTypes2.default.string,
    /**
   * A css class or set of classes applied to the modal container when the modal is open,
   * and removed when it is closed.
   */ containerClassName: $2d33629e68b8dae6$var$_propTypes2.default.string,
    /**
   * Close the modal when escape key is pressed
   */ keyboard: $2d33629e68b8dae6$var$_propTypes2.default.bool,
    /**
   * A `react-transition-group@2.0.0` `<Transition/>` component used
   * to control animations for the dialog component.
   */ transition: $2d33629e68b8dae6$var$_elementType2.default,
    /**
   * A `react-transition-group@2.0.0` `<Transition/>` component used
   * to control animations for the backdrop components.
   */ backdropTransition: $2d33629e68b8dae6$var$_elementType2.default,
    /**
   * When `true` The modal will automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes. This also
   * works correctly with any Modal children that have the `autoFocus` prop.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */ autoFocus: $2d33629e68b8dae6$var$_propTypes2.default.bool,
    /**
   * When `true` The modal will prevent focus from leaving the Modal while open.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */ enforceFocus: $2d33629e68b8dae6$var$_propTypes2.default.bool,
    /**
   * When `true` The modal will restore focus to previously focused element once
   * modal is hidden
   */ restoreFocus: $2d33629e68b8dae6$var$_propTypes2.default.bool,
    /**
   * Callback fired before the Modal transitions in
   */ onEnter: $2d33629e68b8dae6$var$_propTypes2.default.func,
    /**
   * Callback fired as the Modal begins to transition in
   */ onEntering: $2d33629e68b8dae6$var$_propTypes2.default.func,
    /**
   * Callback fired after the Modal finishes transitioning in
   */ onEntered: $2d33629e68b8dae6$var$_propTypes2.default.func,
    /**
   * Callback fired right before the Modal transitions out
   */ onExit: $2d33629e68b8dae6$var$_propTypes2.default.func,
    /**
   * Callback fired as the Modal begins to transition out
   */ onExiting: $2d33629e68b8dae6$var$_propTypes2.default.func,
    /**
   * Callback fired after the Modal finishes transitioning out
   */ onExited: $2d33629e68b8dae6$var$_propTypes2.default.func,
    /**
   * A ModalManager instance used to track and manage the state of open
   * Modals. Useful when customizing how modals interact within a container
   */ manager: $2d33629e68b8dae6$var$_propTypes2.default.object.isRequired
});
$2d33629e68b8dae6$var$Modal.defaultProps = {
    show: false,
    backdrop: true,
    keyboard: true,
    autoFocus: true,
    enforceFocus: true,
    restoreFocus: true,
    onHide: function onHide() {},
    manager: $2d33629e68b8dae6$var$modalManager,
    renderBackdrop: function renderBackdrop(props) {
        return $2d33629e68b8dae6$var$_react2.default.createElement("div", props);
    }
};
var $2d33629e68b8dae6$var$_initialiseProps = function _initialiseProps() {
    var _this2 = this;
    this.state = {
        exited: !this.props.show
    };
    this.renderBackdrop = function() {
        var _props3 = _this2.props, backdropStyle = _props3.backdropStyle, backdropClassName = _props3.backdropClassName, renderBackdrop = _props3.renderBackdrop, Transition = _props3.backdropTransition;
        var backdropRef = function backdropRef(ref) {
            return _this2.backdrop = ref;
        };
        var backdrop = renderBackdrop({
            ref: backdropRef,
            style: backdropStyle,
            className: backdropClassName,
            onClick: _this2.handleBackdropClick
        });
        if (Transition) backdrop = $2d33629e68b8dae6$var$_react2.default.createElement(Transition, {
            appear: true,
            "in": _this2.props.show
        }, backdrop);
        return backdrop;
    };
    this.onPortalRendered = function() {
        _this2.autoFocus();
        if (_this2.props.onShow) _this2.props.onShow();
    };
    this.onShow = function() {
        var doc = (0, $2d33629e68b8dae6$var$_ownerDocument2.default)(_this2);
        var container = (0, $2d33629e68b8dae6$var$_getContainer2.default)(_this2.props.container, doc.body);
        _this2.props.manager.add(_this2, container, _this2.props.containerClassName);
        _this2._onDocumentKeydownListener = (0, $2d33629e68b8dae6$var$_addEventListener2.default)(doc, "keydown", _this2.handleDocumentKeyDown);
        _this2._onDocumentKeyupListener = (0, $2d33629e68b8dae6$var$_addEventListener2.default)(doc, "keyup", _this2.handleDocumentKeyUp);
        _this2._onFocusinListener = (0, $2d33629e68b8dae6$var$_addFocusListener2.default)(_this2.enforceFocus);
    };
    this.onHide = function() {
        _this2.props.manager.remove(_this2);
        _this2._onDocumentKeydownListener.remove();
        _this2._onDocumentKeyupListener.remove();
        _this2._onFocusinListener.remove();
        if (_this2.props.restoreFocus) _this2.restoreLastFocus();
    };
    this.setMountNode = function(ref) {
        _this2.mountNode = ref ? ref.getMountNode() : ref;
    };
    this.setModalNodeRef = function(ref) {
        _this2.modalNode = ref;
    };
    this.setDialogRef = function(ref) {
        _this2.dialog = ref;
    };
    this.handleHidden = function() {
        _this2.setState({
            exited: true
        });
        _this2.onHide();
        if (_this2.props.onExited) {
            var _props4;
            (_props4 = _this2.props).onExited.apply(_props4, arguments);
        }
    };
    this.handleBackdropClick = function(e) {
        if (e.target !== e.currentTarget) return;
        if (_this2.props.onBackdropClick) _this2.props.onBackdropClick(e);
        if (_this2.props.backdrop === true) _this2.props.onHide();
    };
    this.handleDocumentKeyDown = function(e) {
        if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
            if (_this2.props.onEscapeKeyDown) _this2.props.onEscapeKeyDown(e);
            _this2.props.onHide();
        }
    };
    this.handleDocumentKeyUp = function(e) {
        if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
            if (_this2.props.onEscapeKeyUp) _this2.props.onEscapeKeyUp(e);
        }
    };
    this.checkForFocus = function() {
        if ($2d33629e68b8dae6$var$_inDOM2.default) _this2.lastFocus = (0, $2d33629e68b8dae6$var$_activeElement2.default)();
    };
    this.enforceFocus = function() {
        if (!_this2.props.enforceFocus || !_this2._isMounted || !_this2.isTopModal()) return;
        var dialogElement = _this2.getDialogElement();
        var currentActiveElement = (0, $2d33629e68b8dae6$var$_activeElement2.default)((0, $2d33629e68b8dae6$var$_ownerDocument2.default)(_this2));
        if (dialogElement && !(0, $2d33629e68b8dae6$var$_contains2.default)(dialogElement, currentActiveElement)) dialogElement.focus();
    };
};
$2d33629e68b8dae6$var$Modal.Manager = $2d33629e68b8dae6$var$_ModalManager2.default;
module.exports.default = $2d33629e68b8dae6$var$Modal;
module.exports = module.exports["default"];

});
parcelRegister("dFcpi", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");
module.exports.__esModule = true;
module.exports.default = $9f28ba7ea0744f51$var$activeElement;

var $9f28ba7ea0744f51$var$_ownerDocument = $l4FIw((parcelRequire("9HZkw")));
function $9f28ba7ea0744f51$var$activeElement(doc) {
    if (doc === void 0) doc = (0, $9f28ba7ea0744f51$var$_ownerDocument.default)();
    try {
        return doc.activeElement;
    } catch (e) {
    /* ie throws if no active element */ }
}
module.exports = module.exports["default"];

});
parcelRegister("9HZkw", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $7117b412ee1b2b28$var$ownerDocument;
function $7117b412ee1b2b28$var$ownerDocument(node) {
    return node && node.ownerDocument || document;
}
module.exports = module.exports["default"];

});


parcelRegister("7Zt2N", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");
module.exports.__esModule = true;
module.exports.default = void 0;

var $5d14c2703327091f$var$_inDOM = $l4FIw((parcelRequire("iDur4")));
var $5d14c2703327091f$var$_default = function() {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    return $5d14c2703327091f$var$_inDOM.default ? function(context, node) {
        if (context.contains) return context.contains(node);
        else if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
        else return $5d14c2703327091f$var$fallback(context, node);
    } : $5d14c2703327091f$var$fallback;
}();
module.exports.default = $5d14c2703327091f$var$_default;
function $5d14c2703327091f$var$fallback(context, node) {
    if (node) do {
        if (node === context) return true;
    }while (node = node.parentNode);
    return false;
}
module.exports = module.exports["default"];

});
parcelRegister("iDur4", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;
var $d9137a64862b6b22$var$_default = !!(typeof window !== "undefined" && window.document && window.document.createElement);
module.exports.default = $d9137a64862b6b22$var$_default;
module.exports = module.exports["default"];

});


parcelRegister("7c3Xh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $53ccb8d12211bb26$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var $7eprg = parcelRequire("7eprg");
var $53ccb8d12211bb26$var$_react2 = $53ccb8d12211bb26$var$_interopRequireDefault($7eprg);

var $cssyq = parcelRequire("cssyq");
var $53ccb8d12211bb26$var$_createChainableTypeChecker2 = $53ccb8d12211bb26$var$_interopRequireDefault($cssyq);
function $53ccb8d12211bb26$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $53ccb8d12211bb26$var$validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    var propType = typeof propValue === "undefined" ? "undefined" : $53ccb8d12211bb26$var$_typeof(propValue);
    if ($53ccb8d12211bb26$var$_react2.default.isValidElement(propValue)) return new Error("Invalid " + location + " `" + propFullName + "` of type ReactElement " + ("supplied to `" + componentName + "`, expected a ReactComponent or a ") + "DOMElement. You can usually obtain a ReactComponent or DOMElement " + "from a ReactElement by attaching a ref to it.");
    if ((propType !== "object" || typeof propValue.render !== "function") && propValue.nodeType !== 1) return new Error("Invalid " + location + " `" + propFullName + "` of value `" + propValue + "` " + ("supplied to `" + componentName + "`, expected a ReactComponent or a ") + "DOMElement.");
    return null;
}
module.exports.default = (0, $53ccb8d12211bb26$var$_createChainableTypeChecker2.default)($53ccb8d12211bb26$var$validate);
module.exports = module.exports["default"];

});
parcelRegister("cssyq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $911e3fdd188201a8$var$createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ // Mostly taken from ReactPropTypes.
function $911e3fdd188201a8$var$createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        var componentNameSafe = componentName || "<<anonymous>>";
        var propFullNameSafe = propFullName || propName;
        if (props[propName] == null) {
            if (isRequired) return new Error("Required " + location + " `" + propFullNameSafe + "` was not specified " + ("in `" + componentNameSafe + "`."));
            return null;
        }
        for(var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++)args[_key - 6] = arguments[_key];
        return validate.apply(undefined, [
            props,
            propName,
            componentNameSafe,
            location,
            propFullNameSafe
        ].concat(args));
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}
module.exports = module.exports["default"];

});


parcelRegister("hQop9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cfda393cb35fc2d5$var$deprecated;

var $boanT = parcelRequire("boanT");
var $cfda393cb35fc2d5$var$_warning2 = $cfda393cb35fc2d5$var$_interopRequireDefault($boanT);
function $cfda393cb35fc2d5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $cfda393cb35fc2d5$var$warned = {};
function $cfda393cb35fc2d5$var$deprecated(validator, reason) {
    return function validate(props, propName, componentName, location, propFullName) {
        var componentNameSafe = componentName || "<<anonymous>>";
        var propFullNameSafe = propFullName || propName;
        if (props[propName] != null) {
            var messageKey = componentName + "." + propName;
            (0, $cfda393cb35fc2d5$var$_warning2.default)($cfda393cb35fc2d5$var$warned[messageKey], "The " + location + " `" + propFullNameSafe + "` of " + ("`" + componentNameSafe + "` is deprecated. " + reason + "."));
            $cfda393cb35fc2d5$var$warned[messageKey] = true;
        }
        for(var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++)args[_key - 5] = arguments[_key];
        return validator.apply(undefined, [
            props,
            propName,
            componentName,
            location,
            propFullName
        ].concat(args));
    };
}
/* eslint-disable no-underscore-dangle */ function $cfda393cb35fc2d5$var$_resetWarned() {
    $cfda393cb35fc2d5$var$warned = {};
}
$cfda393cb35fc2d5$var$deprecated._resetWarned = $cfda393cb35fc2d5$var$_resetWarned;
/* eslint-enable no-underscore-dangle */ module.exports = module.exports["default"];

});
parcelRegister("boanT", function(module, exports) {
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $84a9fdb473af14ae$var$warning = function() {};
module.exports = $84a9fdb473af14ae$var$warning;

});


parcelRegister("dZHUK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7eprg = parcelRequire("7eprg");
var $a3030958f002fc3e$var$_react2 = $a3030958f002fc3e$var$_interopRequireDefault($7eprg);

var $9RIM4 = parcelRequire("9RIM4");

var $cssyq = parcelRequire("cssyq");
var $a3030958f002fc3e$var$_createChainableTypeChecker2 = $a3030958f002fc3e$var$_interopRequireDefault($cssyq);
function $a3030958f002fc3e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a3030958f002fc3e$var$elementType(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    if ($a3030958f002fc3e$var$_react2.default.isValidElement(propValue)) return new Error("Invalid " + location + " `" + propFullName + "` of type ReactElement " + ("supplied to `" + componentName + "`,expected an element type (a string ") + ", component class, or function component).");
    if (!(0, $9RIM4.isValidElementType)(propValue)) return new Error("Invalid " + location + " `" + propFullName + "` of value `" + propValue + "` " + ("supplied to `" + componentName + "`, expected an element type (a string ") + ", component class, or function component).");
    return null;
}
module.exports.default = (0, $a3030958f002fc3e$var$_createChainableTypeChecker2.default)($a3030958f002fc3e$var$elementType);
module.exports = module.exports["default"];

});

parcelRegister("3vuoS", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $5NKH5 = parcelRequire("5NKH5");
var $28dbd93518645fa7$var$_class2 = $28dbd93518645fa7$var$_interopRequireDefault($5NKH5);

var $iER7J = parcelRequire("iER7J");
var $28dbd93518645fa7$var$_style2 = $28dbd93518645fa7$var$_interopRequireDefault($iER7J);

var $8ZO7y = parcelRequire("8ZO7y");
var $28dbd93518645fa7$var$_scrollbarSize2 = $28dbd93518645fa7$var$_interopRequireDefault($8ZO7y);

var $b2LLl = parcelRequire("b2LLl");
var $28dbd93518645fa7$var$_isOverflowing2 = $28dbd93518645fa7$var$_interopRequireDefault($b2LLl);

var $1O7VE = parcelRequire("1O7VE");
function $28dbd93518645fa7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $28dbd93518645fa7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $28dbd93518645fa7$var$findIndexOf(arr, cb) {
    var idx = -1;
    arr.some(function(d, i) {
        if (cb(d, i)) {
            idx = i;
            return true;
        }
    });
    return idx;
}
function $28dbd93518645fa7$var$findContainer(data, modal) {
    return $28dbd93518645fa7$var$findIndexOf(data, function(d) {
        return d.modals.indexOf(modal) !== -1;
    });
}
function $28dbd93518645fa7$var$setContainerStyle(state, container) {
    var style = {
        overflow: "hidden"
    };
    // we are only interested in the actual `style` here
    // becasue we will override it
    state.style = {
        overflow: container.style.overflow,
        paddingRight: container.style.paddingRight
    };
    if (state.overflowing) // use computed style, here to get the real padding
    // to add our scrollbar width
    style.paddingRight = parseInt((0, $28dbd93518645fa7$var$_style2.default)(container, "paddingRight") || 0, 10) + (0, $28dbd93518645fa7$var$_scrollbarSize2.default)() + "px";
    (0, $28dbd93518645fa7$var$_style2.default)(container, style);
}
function $28dbd93518645fa7$var$removeContainerStyle(_ref, container) {
    var style = _ref.style;
    Object.keys(style).forEach(function(key) {
        return container.style[key] = style[key];
    });
}
/**
 * Proper state managment for containers and the modals in those containers.
 *
 * @internal Used by the Modal to ensure proper styling of containers.
 */ var $28dbd93518645fa7$var$ModalManager = function ModalManager() {
    var _this = this;
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$hideSiblingNode = _ref2.hideSiblingNodes, hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode, _ref2$handleContainer = _ref2.handleContainerOverflow, handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;
    $28dbd93518645fa7$var$_classCallCheck(this, ModalManager);
    this.add = function(modal, container, className) {
        var modalIdx = _this.modals.indexOf(modal);
        var containerIdx = _this.containers.indexOf(container);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = _this.modals.length;
        _this.modals.push(modal);
        if (_this.hideSiblingNodes) (0, $1O7VE.hideSiblings)(container, modal.mountNode);
        if (containerIdx !== -1) {
            _this.data[containerIdx].modals.push(modal);
            return modalIdx;
        }
        var data = {
            modals: [
                modal
            ],
            //right now only the first modal of a container will have its classes applied
            classes: className ? className.split(/\s+/) : [],
            overflowing: (0, $28dbd93518645fa7$var$_isOverflowing2.default)(container)
        };
        if (_this.handleContainerOverflow) $28dbd93518645fa7$var$setContainerStyle(data, container);
        data.classes.forEach($28dbd93518645fa7$var$_class2.default.addClass.bind(null, container));
        _this.containers.push(container);
        _this.data.push(data);
        return modalIdx;
    };
    this.remove = function(modal) {
        var modalIdx = _this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        var containerIdx = $28dbd93518645fa7$var$findContainer(_this.data, modal);
        var data = _this.data[containerIdx];
        var container = _this.containers[containerIdx];
        data.modals.splice(data.modals.indexOf(modal), 1);
        _this.modals.splice(modalIdx, 1);
        // if that was the last modal in a container,
        // clean up the container
        if (data.modals.length === 0) {
            data.classes.forEach($28dbd93518645fa7$var$_class2.default.removeClass.bind(null, container));
            if (_this.handleContainerOverflow) $28dbd93518645fa7$var$removeContainerStyle(data, container);
            if (_this.hideSiblingNodes) (0, $1O7VE.showSiblings)(container, modal.mountNode);
            _this.containers.splice(containerIdx, 1);
            _this.data.splice(containerIdx, 1);
        } else if (_this.hideSiblingNodes) //otherwise make sure the next top modal is visible to a SR
        (0, $1O7VE.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
    };
    this.isTopModal = function(modal) {
        return !!_this.modals.length && _this.modals[_this.modals.length - 1] === modal;
    };
    this.hideSiblingNodes = hideSiblingNodes;
    this.handleContainerOverflow = handleContainerOverflow;
    this.modals = [];
    this.containers = [];
    this.data = [];
};
module.exports.default = $28dbd93518645fa7$var$ModalManager;
module.exports = module.exports["default"];

});
parcelRegister("5NKH5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $4395bfd2e1bb57cb$export$1e511d4a378977f5; }, function (v) { return $4395bfd2e1bb57cb$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $4395bfd2e1bb57cb$export$2e2bcd8739ae039; }, function (v) { return $4395bfd2e1bb57cb$export$2e2bcd8739ae039 = v; });
$parcel$export(module.exports, "addClass", function () { return $4395bfd2e1bb57cb$export$d2cf6cd1dc7067d3; }, function (v) { return $4395bfd2e1bb57cb$export$d2cf6cd1dc7067d3 = v; });
$parcel$export(module.exports, "removeClass", function () { return $4395bfd2e1bb57cb$export$c2255604a80b4506; }, function (v) { return $4395bfd2e1bb57cb$export$c2255604a80b4506 = v; });
$parcel$export(module.exports, "hasClass", function () { return $4395bfd2e1bb57cb$export$4ea3d958472af68f; }, function (v) { return $4395bfd2e1bb57cb$export$4ea3d958472af68f = v; });
var $4395bfd2e1bb57cb$export$1e511d4a378977f5;
var $4395bfd2e1bb57cb$export$2e2bcd8739ae039;
var $4395bfd2e1bb57cb$export$d2cf6cd1dc7067d3;
var $4395bfd2e1bb57cb$export$c2255604a80b4506;
var $4395bfd2e1bb57cb$export$4ea3d958472af68f;
"use strict";

var $l4FIw = parcelRequire("l4FIw");
$4395bfd2e1bb57cb$export$1e511d4a378977f5 = true;
$4395bfd2e1bb57cb$export$2e2bcd8739ae039 = void 0;

var $4395bfd2e1bb57cb$var$_addClass = $l4FIw((parcelRequire("4lw98")));
$4395bfd2e1bb57cb$export$d2cf6cd1dc7067d3 = $4395bfd2e1bb57cb$var$_addClass.default;

var $4395bfd2e1bb57cb$var$_removeClass = $l4FIw((parcelRequire("1ITXo")));
$4395bfd2e1bb57cb$export$c2255604a80b4506 = $4395bfd2e1bb57cb$var$_removeClass.default;

var $4395bfd2e1bb57cb$var$_hasClass = $l4FIw((parcelRequire("lIiG8")));
$4395bfd2e1bb57cb$export$4ea3d958472af68f = $4395bfd2e1bb57cb$var$_hasClass.default;
var $4395bfd2e1bb57cb$var$_default = {
    addClass: $4395bfd2e1bb57cb$var$_addClass.default,
    removeClass: $4395bfd2e1bb57cb$var$_removeClass.default,
    hasClass: $4395bfd2e1bb57cb$var$_hasClass.default
};
$4395bfd2e1bb57cb$export$2e2bcd8739ae039 = $4395bfd2e1bb57cb$var$_default;

});

parcelRegister("iER7J", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");
module.exports.__esModule = true;
module.exports.default = $d9552bae7adbf158$var$style;

var $d9552bae7adbf158$var$_camelizeStyle = $l4FIw((parcelRequire("HyFWz")));

var $d9552bae7adbf158$var$_hyphenateStyle = $l4FIw((parcelRequire("koyBq")));

var $d9552bae7adbf158$var$_getComputedStyle2 = $l4FIw((parcelRequire("5vb0Z")));

var $d9552bae7adbf158$var$_removeStyle = $l4FIw((parcelRequire("jLUOf")));

var $56RpV = parcelRequire("56RpV");

var $d9552bae7adbf158$var$_isTransform = $l4FIw((parcelRequire("iSCdP")));
function $d9552bae7adbf158$var$style(node, property, value) {
    var css = "";
    var transforms = "";
    var props = property;
    if (typeof property === "string") {
        if (value === undefined) return node.style[(0, $d9552bae7adbf158$var$_camelizeStyle.default)(property)] || (0, $d9552bae7adbf158$var$_getComputedStyle2.default)(node).getPropertyValue((0, $d9552bae7adbf158$var$_hyphenateStyle.default)(property));
        else (props = {})[property] = value;
    }
    Object.keys(props).forEach(function(key) {
        var value = props[key];
        if (!value && value !== 0) (0, $d9552bae7adbf158$var$_removeStyle.default)(node, (0, $d9552bae7adbf158$var$_hyphenateStyle.default)(key));
        else if ((0, $d9552bae7adbf158$var$_isTransform.default)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $d9552bae7adbf158$var$_hyphenateStyle.default)(key) + ": " + value + ";";
    });
    if (transforms) css += $56RpV.transform + ": " + transforms + ";";
    node.style.cssText += ";" + css;
}
module.exports = module.exports["default"];

});
parcelRegister("HyFWz", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");
module.exports.__esModule = true;
module.exports.default = $082eea19cdd66ff4$var$camelizeStyleName;

var $082eea19cdd66ff4$var$_camelize = $l4FIw((parcelRequire("1qCxe")));
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
 */ var $082eea19cdd66ff4$var$msPattern = /^-ms-/;
function $082eea19cdd66ff4$var$camelizeStyleName(string) {
    return (0, $082eea19cdd66ff4$var$_camelize.default)(string.replace($082eea19cdd66ff4$var$msPattern, "ms-"));
}
module.exports = module.exports["default"];

});
parcelRegister("1qCxe", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $10a61c655ef6e1d6$var$camelize;
var $10a61c655ef6e1d6$var$rHyphen = /-(.)/g;
function $10a61c655ef6e1d6$var$camelize(string) {
    return string.replace($10a61c655ef6e1d6$var$rHyphen, function(_, chr) {
        return chr.toUpperCase();
    });
}
module.exports = module.exports["default"];

});


parcelRegister("koyBq", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");
module.exports.__esModule = true;
module.exports.default = $ed90e3e97fd7d1b4$var$hyphenateStyleName;

var $ed90e3e97fd7d1b4$var$_hyphenate = $l4FIw((parcelRequire("lBUGo")));
/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $ed90e3e97fd7d1b4$var$msPattern = /^ms-/;
function $ed90e3e97fd7d1b4$var$hyphenateStyleName(string) {
    return (0, $ed90e3e97fd7d1b4$var$_hyphenate.default)(string).replace($ed90e3e97fd7d1b4$var$msPattern, "-ms-");
}
module.exports = module.exports["default"];

});
parcelRegister("lBUGo", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $fbb905b11bddf773$var$hyphenate;
var $fbb905b11bddf773$var$rUpper = /([A-Z])/g;
function $fbb905b11bddf773$var$hyphenate(string) {
    return string.replace($fbb905b11bddf773$var$rUpper, "-$1").toLowerCase();
}
module.exports = module.exports["default"];

});


parcelRegister("5vb0Z", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");
module.exports.__esModule = true;
module.exports.default = $4018645a32541646$var$_getComputedStyle;

var $4018645a32541646$var$_camelizeStyle = $l4FIw((parcelRequire("HyFWz")));
var $4018645a32541646$var$rposition = /^(top|right|bottom|left)$/;
var $4018645a32541646$var$rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
function $4018645a32541646$var$_getComputedStyle(node) {
    if (!node) throw new TypeError("No Element passed to `getComputedStyle()`");
    var doc = node.ownerDocument;
    return "defaultView" in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
        //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
        getPropertyValue: function getPropertyValue(prop) {
            var style = node.style;
            prop = (0, $4018645a32541646$var$_camelizeStyle.default)(prop);
            if (prop == "float") prop = "styleFloat";
            var current = node.currentStyle[prop] || null;
            if (current == null && style && style[prop]) current = style[prop];
            if ($4018645a32541646$var$rnumnonpx.test(current) && !$4018645a32541646$var$rposition.test(prop)) {
                // Remember the original values
                var left = style.left;
                var runStyle = node.runtimeStyle;
                var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out
                if (rsLeft) runStyle.left = node.currentStyle.left;
                style.left = prop === "fontSize" ? "1em" : current;
                current = style.pixelLeft + "px"; // Revert the changed values
                style.left = left;
                if (rsLeft) runStyle.left = rsLeft;
            }
            return current;
        }
    };
}
module.exports = module.exports["default"];

});

parcelRegister("jLUOf", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $e64e7943d23e5a56$var$removeStyle;
function $e64e7943d23e5a56$var$removeStyle(node, key) {
    return "removeProperty" in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}
module.exports = module.exports["default"];

});

parcelRegister("56RpV", function(module, exports) {

$parcel$export(module.exports, "transform", function () { return $3b86f2d78dda4326$export$51186ad6e864892a; }, function (v) { return $3b86f2d78dda4326$export$51186ad6e864892a = v; });
var $3b86f2d78dda4326$export$1e511d4a378977f5;
var $3b86f2d78dda4326$export$2e2bcd8739ae039;
var $3b86f2d78dda4326$export$70f051812b89bf32;
var $3b86f2d78dda4326$export$749d4cba267d0cfb;
var $3b86f2d78dda4326$export$ffa43e98d6c6fda0;
var $3b86f2d78dda4326$export$82f5c257a11c5515;
var $3b86f2d78dda4326$export$3661f43c23499d48;
var $3b86f2d78dda4326$export$358dc01d65cad417;
var $3b86f2d78dda4326$export$3105270315df0e7;
var $3b86f2d78dda4326$export$48c3efaeac751014;
var $3b86f2d78dda4326$export$17443db69dc7b37a;
var $3b86f2d78dda4326$export$88a474443352206c;
var $3b86f2d78dda4326$export$51186ad6e864892a;
"use strict";

var $l4FIw = parcelRequire("l4FIw");
$3b86f2d78dda4326$export$1e511d4a378977f5 = true;
$3b86f2d78dda4326$export$2e2bcd8739ae039 = $3b86f2d78dda4326$export$70f051812b89bf32 = $3b86f2d78dda4326$export$749d4cba267d0cfb = $3b86f2d78dda4326$export$ffa43e98d6c6fda0 = $3b86f2d78dda4326$export$82f5c257a11c5515 = $3b86f2d78dda4326$export$3661f43c23499d48 = $3b86f2d78dda4326$export$358dc01d65cad417 = $3b86f2d78dda4326$export$3105270315df0e7 = $3b86f2d78dda4326$export$48c3efaeac751014 = $3b86f2d78dda4326$export$17443db69dc7b37a = $3b86f2d78dda4326$export$88a474443352206c = $3b86f2d78dda4326$export$51186ad6e864892a = void 0;

var $3b86f2d78dda4326$var$_inDOM = $l4FIw((parcelRequire("iDur4")));
var $3b86f2d78dda4326$var$transform = "transform";
$3b86f2d78dda4326$export$51186ad6e864892a = $3b86f2d78dda4326$var$transform;
var $3b86f2d78dda4326$var$prefix, $3b86f2d78dda4326$var$transitionEnd, $3b86f2d78dda4326$var$animationEnd;
$3b86f2d78dda4326$export$70f051812b89bf32 = $3b86f2d78dda4326$var$animationEnd;
$3b86f2d78dda4326$export$358dc01d65cad417 = $3b86f2d78dda4326$var$transitionEnd;
var $3b86f2d78dda4326$var$transitionProperty, $3b86f2d78dda4326$var$transitionDuration, $3b86f2d78dda4326$var$transitionTiming, $3b86f2d78dda4326$var$transitionDelay;
$3b86f2d78dda4326$export$48c3efaeac751014 = $3b86f2d78dda4326$var$transitionDelay;
$3b86f2d78dda4326$export$17443db69dc7b37a = $3b86f2d78dda4326$var$transitionTiming;
$3b86f2d78dda4326$export$3105270315df0e7 = $3b86f2d78dda4326$var$transitionDuration;
$3b86f2d78dda4326$export$88a474443352206c = $3b86f2d78dda4326$var$transitionProperty;
var $3b86f2d78dda4326$var$animationName, $3b86f2d78dda4326$var$animationDuration, $3b86f2d78dda4326$var$animationTiming, $3b86f2d78dda4326$var$animationDelay;
$3b86f2d78dda4326$export$749d4cba267d0cfb = $3b86f2d78dda4326$var$animationDelay;
$3b86f2d78dda4326$export$ffa43e98d6c6fda0 = $3b86f2d78dda4326$var$animationTiming;
$3b86f2d78dda4326$export$82f5c257a11c5515 = $3b86f2d78dda4326$var$animationDuration;
$3b86f2d78dda4326$export$3661f43c23499d48 = $3b86f2d78dda4326$var$animationName;
if ($3b86f2d78dda4326$var$_inDOM.default) {
    var $3b86f2d78dda4326$var$_getTransitionPropert = $3b86f2d78dda4326$var$getTransitionProperties();
    $3b86f2d78dda4326$var$prefix = $3b86f2d78dda4326$var$_getTransitionPropert.prefix;
    $3b86f2d78dda4326$export$358dc01d65cad417 = $3b86f2d78dda4326$var$transitionEnd = $3b86f2d78dda4326$var$_getTransitionPropert.transitionEnd;
    $3b86f2d78dda4326$export$70f051812b89bf32 = $3b86f2d78dda4326$var$animationEnd = $3b86f2d78dda4326$var$_getTransitionPropert.animationEnd;
    $3b86f2d78dda4326$export$51186ad6e864892a = $3b86f2d78dda4326$var$transform = $3b86f2d78dda4326$var$prefix + "-" + $3b86f2d78dda4326$var$transform;
    $3b86f2d78dda4326$export$88a474443352206c = $3b86f2d78dda4326$var$transitionProperty = $3b86f2d78dda4326$var$prefix + "-transition-property";
    $3b86f2d78dda4326$export$3105270315df0e7 = $3b86f2d78dda4326$var$transitionDuration = $3b86f2d78dda4326$var$prefix + "-transition-duration";
    $3b86f2d78dda4326$export$48c3efaeac751014 = $3b86f2d78dda4326$var$transitionDelay = $3b86f2d78dda4326$var$prefix + "-transition-delay";
    $3b86f2d78dda4326$export$17443db69dc7b37a = $3b86f2d78dda4326$var$transitionTiming = $3b86f2d78dda4326$var$prefix + "-transition-timing-function";
    $3b86f2d78dda4326$export$3661f43c23499d48 = $3b86f2d78dda4326$var$animationName = $3b86f2d78dda4326$var$prefix + "-animation-name";
    $3b86f2d78dda4326$export$82f5c257a11c5515 = $3b86f2d78dda4326$var$animationDuration = $3b86f2d78dda4326$var$prefix + "-animation-duration";
    $3b86f2d78dda4326$export$ffa43e98d6c6fda0 = $3b86f2d78dda4326$var$animationTiming = $3b86f2d78dda4326$var$prefix + "-animation-delay";
    $3b86f2d78dda4326$export$749d4cba267d0cfb = $3b86f2d78dda4326$var$animationDelay = $3b86f2d78dda4326$var$prefix + "-animation-timing-function";
}
var $3b86f2d78dda4326$var$_default = {
    transform: $3b86f2d78dda4326$var$transform,
    end: $3b86f2d78dda4326$var$transitionEnd,
    property: $3b86f2d78dda4326$var$transitionProperty,
    timing: $3b86f2d78dda4326$var$transitionTiming,
    delay: $3b86f2d78dda4326$var$transitionDelay,
    duration: $3b86f2d78dda4326$var$transitionDuration
};
$3b86f2d78dda4326$export$2e2bcd8739ae039 = $3b86f2d78dda4326$var$_default;
function $3b86f2d78dda4326$var$getTransitionProperties() {
    var style = document.createElement("div").style;
    var vendorMap = {
        O: function O(e) {
            return "o" + e.toLowerCase();
        },
        Moz: function Moz(e) {
            return e.toLowerCase();
        },
        Webkit: function Webkit(e) {
            return "webkit" + e;
        },
        ms: function ms(e) {
            return "MS" + e;
        }
    };
    var vendors = Object.keys(vendorMap);
    var transitionEnd, animationEnd;
    var prefix = "";
    for(var i = 0; i < vendors.length; i++){
        var vendor = vendors[i];
        if (vendor + "TransitionProperty" in style) {
            prefix = "-" + vendor.toLowerCase();
            transitionEnd = vendorMap[vendor]("TransitionEnd");
            animationEnd = vendorMap[vendor]("AnimationEnd");
            break;
        }
    }
    if (!transitionEnd && "transitionProperty" in style) transitionEnd = "transitionend";
    if (!animationEnd && "animationName" in style) animationEnd = "animationend";
    style = null;
    return {
        animationEnd: animationEnd,
        transitionEnd: transitionEnd,
        prefix: prefix
    };
}

});

parcelRegister("iSCdP", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $dbeaeb4165f2434b$var$isTransform;
var $dbeaeb4165f2434b$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $dbeaeb4165f2434b$var$isTransform(property) {
    return !!(property && $dbeaeb4165f2434b$var$supportedTransforms.test(property));
}
module.exports = module.exports["default"];

});


parcelRegister("8ZO7y", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");
module.exports.__esModule = true;
module.exports.default = $68cae6360fcca781$var$scrollbarSize;

var $68cae6360fcca781$var$_inDOM = $l4FIw((parcelRequire("iDur4")));
var $68cae6360fcca781$var$size;
function $68cae6360fcca781$var$scrollbarSize(recalc) {
    if (!$68cae6360fcca781$var$size && $68cae6360fcca781$var$size !== 0 || recalc) {
        if ($68cae6360fcca781$var$_inDOM.default) {
            var scrollDiv = document.createElement("div");
            scrollDiv.style.position = "absolute";
            scrollDiv.style.top = "-9999px";
            scrollDiv.style.width = "50px";
            scrollDiv.style.height = "50px";
            scrollDiv.style.overflow = "scroll";
            document.body.appendChild(scrollDiv);
            $68cae6360fcca781$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $68cae6360fcca781$var$size;
}
module.exports = module.exports["default"];

});

parcelRegister("b2LLl", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $80a4ee4360b38ec4$var$isOverflowing;

var $26Aq5 = parcelRequire("26Aq5");
var $80a4ee4360b38ec4$var$_isWindow2 = $80a4ee4360b38ec4$var$_interopRequireDefault($26Aq5);

var $9HZkw = parcelRequire("9HZkw");
var $80a4ee4360b38ec4$var$_ownerDocument2 = $80a4ee4360b38ec4$var$_interopRequireDefault($9HZkw);
function $80a4ee4360b38ec4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $80a4ee4360b38ec4$var$isBody(node) {
    return node && node.tagName.toLowerCase() === "body";
}
function $80a4ee4360b38ec4$var$bodyIsOverflowing(node) {
    var doc = (0, $80a4ee4360b38ec4$var$_ownerDocument2.default)(node);
    var win = (0, $80a4ee4360b38ec4$var$_isWindow2.default)(doc);
    var fullWidth = win.innerWidth;
    // Support: ie8, no innerWidth
    if (!fullWidth) {
        var documentElementRect = doc.documentElement.getBoundingClientRect();
        fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
    }
    return doc.body.clientWidth < fullWidth;
}
function $80a4ee4360b38ec4$var$isOverflowing(container) {
    var win = (0, $80a4ee4360b38ec4$var$_isWindow2.default)(container);
    return win || $80a4ee4360b38ec4$var$isBody(container) ? $80a4ee4360b38ec4$var$bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
}
module.exports = module.exports["default"];

});
parcelRegister("26Aq5", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $18886488562a0f3d$var$getWindow;
function $18886488562a0f3d$var$getWindow(node) {
    return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}
module.exports = module.exports["default"];

});


parcelRegister("1O7VE", function(module, exports) {

$parcel$export(module.exports, "ariaHidden", function () { return $15109c73e6c750e4$export$e1bd0c6150f13d96; }, function (v) { return $15109c73e6c750e4$export$e1bd0c6150f13d96 = v; });
$parcel$export(module.exports, "hideSiblings", function () { return $15109c73e6c750e4$export$18dbef20832f547a; }, function (v) { return $15109c73e6c750e4$export$18dbef20832f547a = v; });
$parcel$export(module.exports, "showSiblings", function () { return $15109c73e6c750e4$export$9b9b63d3e0115d40; }, function (v) { return $15109c73e6c750e4$export$9b9b63d3e0115d40 = v; });
var $15109c73e6c750e4$export$1e511d4a378977f5;
var $15109c73e6c750e4$export$e1bd0c6150f13d96;
var $15109c73e6c750e4$export$18dbef20832f547a;
var $15109c73e6c750e4$export$9b9b63d3e0115d40;
"use strict";
$15109c73e6c750e4$export$1e511d4a378977f5 = true;
$15109c73e6c750e4$export$e1bd0c6150f13d96 = $15109c73e6c750e4$var$ariaHidden;
$15109c73e6c750e4$export$18dbef20832f547a = $15109c73e6c750e4$var$hideSiblings;
$15109c73e6c750e4$export$9b9b63d3e0115d40 = $15109c73e6c750e4$var$showSiblings;
var $15109c73e6c750e4$var$BLACKLIST = [
    "template",
    "script",
    "style"
];
var $15109c73e6c750e4$var$isHidable = function isHidable(_ref) {
    var nodeType = _ref.nodeType, tagName = _ref.tagName;
    return nodeType === 1 && $15109c73e6c750e4$var$BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
};
var $15109c73e6c750e4$var$siblings = function siblings(container, mount, cb) {
    mount = [].concat(mount);
    [].forEach.call(container.children, function(node) {
        if (mount.indexOf(node) === -1 && $15109c73e6c750e4$var$isHidable(node)) cb(node);
    });
};
function $15109c73e6c750e4$var$ariaHidden(show, node) {
    if (!node) return;
    if (show) node.setAttribute("aria-hidden", "true");
    else node.removeAttribute("aria-hidden");
}
function $15109c73e6c750e4$var$hideSiblings(container, mountNode) {
    $15109c73e6c750e4$var$siblings(container, mountNode, function(node) {
        return $15109c73e6c750e4$var$ariaHidden(true, node);
    });
}
function $15109c73e6c750e4$var$showSiblings(container, mountNode) {
    $15109c73e6c750e4$var$siblings(container, mountNode, function(node) {
        return $15109c73e6c750e4$var$ariaHidden(false, node);
    });
}

});


parcelRegister("kkZS4", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $h4kRK = parcelRequire("h4kRK");
var $ece5ab39221ef18b$var$_propTypes2 = $ece5ab39221ef18b$var$_interopRequireDefault($h4kRK);

var $7c3Xh = parcelRequire("7c3Xh");
var $ece5ab39221ef18b$var$_componentOrElement2 = $ece5ab39221ef18b$var$_interopRequireDefault($7c3Xh);

var $7eprg = parcelRequire("7eprg");
var $ece5ab39221ef18b$var$_react2 = $ece5ab39221ef18b$var$_interopRequireDefault($7eprg);

var $5hg2n = parcelRequire("5hg2n");
var $ece5ab39221ef18b$var$_reactDom2 = $ece5ab39221ef18b$var$_interopRequireDefault($5hg2n);

var $aK5Rh = parcelRequire("aK5Rh");
var $ece5ab39221ef18b$var$_getContainer2 = $ece5ab39221ef18b$var$_interopRequireDefault($aK5Rh);

var $bi5EL = parcelRequire("bi5EL");
var $ece5ab39221ef18b$var$_ownerDocument2 = $ece5ab39221ef18b$var$_interopRequireDefault($bi5EL);

var $aqPLI = parcelRequire("aqPLI");
var $ece5ab39221ef18b$var$_LegacyPortal2 = $ece5ab39221ef18b$var$_interopRequireDefault($aqPLI);
function $ece5ab39221ef18b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ece5ab39221ef18b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ece5ab39221ef18b$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $ece5ab39221ef18b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */ var $ece5ab39221ef18b$var$Portal = function(_React$Component) {
    $ece5ab39221ef18b$var$_inherits(Portal, _React$Component);
    function Portal() {
        var _temp, _this, _ret;
        $ece5ab39221ef18b$var$_classCallCheck(this, Portal);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $ece5ab39221ef18b$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.setContainer = function() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
            _this._portalContainerNode = (0, $ece5ab39221ef18b$var$_getContainer2.default)(props.container, (0, $ece5ab39221ef18b$var$_ownerDocument2.default)(_this).body);
        }, _this.getMountNode = function() {
            return _this._portalContainerNode;
        }, _temp), $ece5ab39221ef18b$var$_possibleConstructorReturn(_this, _ret);
    }
    Portal.prototype.componentDidMount = function componentDidMount() {
        this.setContainer();
        this.forceUpdate(this.props.onRendered);
    };
    Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (nextProps.container !== this.props.container) this.setContainer(nextProps);
    };
    Portal.prototype.componentWillUnmount = function componentWillUnmount() {
        this._portalContainerNode = null;
    };
    Portal.prototype.render = function render() {
        return this.props.children && this._portalContainerNode ? $ece5ab39221ef18b$var$_reactDom2.default.createPortal(this.props.children, this._portalContainerNode) : null;
    };
    return Portal;
}($ece5ab39221ef18b$var$_react2.default.Component);
$ece5ab39221ef18b$var$Portal.displayName = "Portal";
$ece5ab39221ef18b$var$Portal.propTypes = {
    /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */ container: $ece5ab39221ef18b$var$_propTypes2.default.oneOfType([
        $ece5ab39221ef18b$var$_componentOrElement2.default,
        $ece5ab39221ef18b$var$_propTypes2.default.func
    ]),
    onRendered: $ece5ab39221ef18b$var$_propTypes2.default.func
};
module.exports.default = $ece5ab39221ef18b$var$_reactDom2.default.createPortal ? $ece5ab39221ef18b$var$Portal : $ece5ab39221ef18b$var$_LegacyPortal2.default;
module.exports = module.exports["default"];

});
parcelRegister("aK5Rh", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $7d22be9ce98c0ef4$var$getContainer;

var $5hg2n = parcelRequire("5hg2n");
var $7d22be9ce98c0ef4$var$_reactDom2 = $7d22be9ce98c0ef4$var$_interopRequireDefault($5hg2n);
function $7d22be9ce98c0ef4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7d22be9ce98c0ef4$var$getContainer(container, defaultContainer) {
    container = typeof container === "function" ? container() : container;
    return $7d22be9ce98c0ef4$var$_reactDom2.default.findDOMNode(container) || defaultContainer;
}
module.exports = module.exports["default"];

});

parcelRegister("bi5EL", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = function(componentOrElement) {
    return (0, $8385c3647dd5c942$var$_ownerDocument2.default)($8385c3647dd5c942$var$_reactDom2.default.findDOMNode(componentOrElement));
};

var $5hg2n = parcelRequire("5hg2n");
var $8385c3647dd5c942$var$_reactDom2 = $8385c3647dd5c942$var$_interopRequireDefault($5hg2n);

var $9HZkw = parcelRequire("9HZkw");
var $8385c3647dd5c942$var$_ownerDocument2 = $8385c3647dd5c942$var$_interopRequireDefault($9HZkw);
function $8385c3647dd5c942$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports = module.exports["default"];

});

parcelRegister("aqPLI", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $h4kRK = parcelRequire("h4kRK");
var $79847d3f80203342$var$_propTypes2 = $79847d3f80203342$var$_interopRequireDefault($h4kRK);

var $7c3Xh = parcelRequire("7c3Xh");
var $79847d3f80203342$var$_componentOrElement2 = $79847d3f80203342$var$_interopRequireDefault($7c3Xh);

var $7eprg = parcelRequire("7eprg");
var $79847d3f80203342$var$_react2 = $79847d3f80203342$var$_interopRequireDefault($7eprg);

var $5hg2n = parcelRequire("5hg2n");
var $79847d3f80203342$var$_reactDom2 = $79847d3f80203342$var$_interopRequireDefault($5hg2n);

var $aK5Rh = parcelRequire("aK5Rh");
var $79847d3f80203342$var$_getContainer2 = $79847d3f80203342$var$_interopRequireDefault($aK5Rh);

var $bi5EL = parcelRequire("bi5EL");
var $79847d3f80203342$var$_ownerDocument2 = $79847d3f80203342$var$_interopRequireDefault($bi5EL);
function $79847d3f80203342$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $79847d3f80203342$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $79847d3f80203342$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $79847d3f80203342$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */ var $79847d3f80203342$var$Portal = function(_React$Component) {
    $79847d3f80203342$var$_inherits(Portal, _React$Component);
    function Portal() {
        var _temp, _this, _ret;
        $79847d3f80203342$var$_classCallCheck(this, Portal);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $79847d3f80203342$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this._mountOverlayTarget = function() {
            if (!_this._overlayTarget) {
                _this._overlayTarget = document.createElement("div");
                _this._portalContainerNode = (0, $79847d3f80203342$var$_getContainer2.default)(_this.props.container, (0, $79847d3f80203342$var$_ownerDocument2.default)(_this).body);
                _this._portalContainerNode.appendChild(_this._overlayTarget);
            }
        }, _this._unmountOverlayTarget = function() {
            if (_this._overlayTarget) {
                _this._portalContainerNode.removeChild(_this._overlayTarget);
                _this._overlayTarget = null;
            }
            _this._portalContainerNode = null;
        }, _this._renderOverlay = function() {
            var overlay = !_this.props.children ? null : $79847d3f80203342$var$_react2.default.Children.only(_this.props.children);
            // Save reference for future access.
            if (overlay !== null) {
                _this._mountOverlayTarget();
                var initialRender = !_this._overlayInstance;
                _this._overlayInstance = $79847d3f80203342$var$_reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget, function() {
                    if (initialRender && _this.props.onRendered) _this.props.onRendered();
                });
            } else {
                // Unrender if the component is null for transitions to null
                _this._unrenderOverlay();
                _this._unmountOverlayTarget();
            }
        }, _this._unrenderOverlay = function() {
            if (_this._overlayTarget) {
                $79847d3f80203342$var$_reactDom2.default.unmountComponentAtNode(_this._overlayTarget);
                _this._overlayInstance = null;
            }
        }, _this.getMountNode = function() {
            return _this._overlayTarget;
        }, _temp), $79847d3f80203342$var$_possibleConstructorReturn(_this, _ret);
    }
    Portal.prototype.componentDidMount = function componentDidMount() {
        this._isMounted = true;
        this._renderOverlay();
    };
    Portal.prototype.componentDidUpdate = function componentDidUpdate() {
        this._renderOverlay();
    };
    Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (this._overlayTarget && nextProps.container !== this.props.container) {
            this._portalContainerNode.removeChild(this._overlayTarget);
            this._portalContainerNode = (0, $79847d3f80203342$var$_getContainer2.default)(nextProps.container, (0, $79847d3f80203342$var$_ownerDocument2.default)(this).body);
            this._portalContainerNode.appendChild(this._overlayTarget);
        }
    };
    Portal.prototype.componentWillUnmount = function componentWillUnmount() {
        this._isMounted = false;
        this._unrenderOverlay();
        this._unmountOverlayTarget();
    };
    Portal.prototype.render = function render() {
        return null;
    };
    return Portal;
}($79847d3f80203342$var$_react2.default.Component);
$79847d3f80203342$var$Portal.displayName = "Portal";
$79847d3f80203342$var$Portal.propTypes = {
    /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */ container: $79847d3f80203342$var$_propTypes2.default.oneOfType([
        $79847d3f80203342$var$_componentOrElement2.default,
        $79847d3f80203342$var$_propTypes2.default.func
    ]),
    onRendered: $79847d3f80203342$var$_propTypes2.default.func
};
module.exports.default = $79847d3f80203342$var$Portal;
module.exports = module.exports["default"];

});


parcelRegister("1FFBs", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $h4kRK = parcelRequire("h4kRK");
var $1379e44be6b56f12$var$_propTypes2 = $1379e44be6b56f12$var$_interopRequireDefault($h4kRK);

var $7eprg = parcelRequire("7eprg");
var $1379e44be6b56f12$var$_react2 = $1379e44be6b56f12$var$_interopRequireDefault($7eprg);
function $1379e44be6b56f12$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1379e44be6b56f12$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1379e44be6b56f12$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $1379e44be6b56f12$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $1379e44be6b56f12$var$propTypes = {
    children: $1379e44be6b56f12$var$_propTypes2.default.node
};
/**
 * Internal helper component to allow attaching a non-conflicting ref to a
 * child element that may not accept refs.
 */ var $1379e44be6b56f12$var$RefHolder = function(_React$Component) {
    $1379e44be6b56f12$var$_inherits(RefHolder, _React$Component);
    function RefHolder() {
        $1379e44be6b56f12$var$_classCallCheck(this, RefHolder);
        return $1379e44be6b56f12$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    RefHolder.prototype.render = function render() {
        return this.props.children;
    };
    return RefHolder;
}($1379e44be6b56f12$var$_react2.default.Component);
$1379e44be6b56f12$var$RefHolder.propTypes = $1379e44be6b56f12$var$propTypes;
module.exports.default = $1379e44be6b56f12$var$RefHolder;
module.exports = module.exports["default"];

});

parcelRegister("cSIz2", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = function(node, event, handler, capture) {
    (0, $960d18b03a164127$var$_on2.default)(node, event, handler, capture);
    return {
        remove: function remove() {
            (0, $960d18b03a164127$var$_off2.default)(node, event, handler, capture);
        }
    };
};

var $fJLnm = parcelRequire("fJLnm");
var $960d18b03a164127$var$_on2 = $960d18b03a164127$var$_interopRequireDefault($fJLnm);

var $1uT4H = parcelRequire("1uT4H");
var $960d18b03a164127$var$_off2 = $960d18b03a164127$var$_interopRequireDefault($1uT4H);
function $960d18b03a164127$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports = module.exports["default"];

});
parcelRegister("fJLnm", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");
module.exports.__esModule = true;
module.exports.default = void 0;

var $b74fced224a6252b$var$_inDOM = $l4FIw((parcelRequire("iDur4")));
var $b74fced224a6252b$var$on = function on() {};
if ($b74fced224a6252b$var$_inDOM.default) $b74fced224a6252b$var$on = function() {
    if (document.addEventListener) return function(node, eventName, handler, capture) {
        return node.addEventListener(eventName, handler, capture || false);
    };
    else if (document.attachEvent) return function(node, eventName, handler) {
        return node.attachEvent("on" + eventName, function(e) {
            e = e || window.event;
            e.target = e.target || e.srcElement;
            e.currentTarget = node;
            handler.call(node, e);
        });
    };
}();
var $b74fced224a6252b$var$_default = $b74fced224a6252b$var$on;
module.exports.default = $b74fced224a6252b$var$_default;
module.exports = module.exports["default"];

});

parcelRegister("1uT4H", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");
module.exports.__esModule = true;
module.exports.default = void 0;

var $11735081313be9cb$var$_inDOM = $l4FIw((parcelRequire("iDur4")));
var $11735081313be9cb$var$off = function off() {};
if ($11735081313be9cb$var$_inDOM.default) $11735081313be9cb$var$off = function() {
    if (document.addEventListener) return function(node, eventName, handler, capture) {
        return node.removeEventListener(eventName, handler, capture || false);
    };
    else if (document.attachEvent) return function(node, eventName, handler) {
        return node.detachEvent("on" + eventName, handler);
    };
}();
var $11735081313be9cb$var$_default = $11735081313be9cb$var$off;
module.exports.default = $11735081313be9cb$var$_default;
module.exports = module.exports["default"];

});


parcelRegister("9haex", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $6c0da3bb1f856cb3$var$addFocusListener;
/**
 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
 *
 * We only allow one Listener at a time to avoid stack overflows
 */ function $6c0da3bb1f856cb3$var$addFocusListener(handler) {
    var useFocusin = !document.addEventListener;
    var remove = void 0;
    if (useFocusin) {
        document.attachEvent("onfocusin", handler);
        remove = function remove() {
            return document.detachEvent("onfocusin", handler);
        };
    } else {
        document.addEventListener("focus", handler, true);
        remove = function remove() {
            return document.removeEventListener("focus", handler, true);
        };
    }
    return {
        remove: remove
    };
}
module.exports = module.exports["default"];

});


parcelRegister("gBQ6d", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");
module.exports.__esModule = true;
module.exports.default = $c17883e019a1df33$var$closest;

var $c17883e019a1df33$var$_matches = $l4FIw((parcelRequire("gqXHR")));
var $c17883e019a1df33$var$isDoc = function isDoc(obj) {
    return obj != null && obj.nodeType === obj.DOCUMENT_NODE;
};
function $c17883e019a1df33$var$closest(node, selector, context) {
    while(node && ($c17883e019a1df33$var$isDoc(node) || !(0, $c17883e019a1df33$var$_matches.default)(node, selector)))node = node !== context && !$c17883e019a1df33$var$isDoc(node) ? node.parentNode : undefined;
    return node;
}
module.exports = module.exports["default"];

});
parcelRegister("gqXHR", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");
module.exports.__esModule = true;
module.exports.default = $bf6d63841b1b6f50$var$matches;

var $bf6d63841b1b6f50$var$_inDOM = $l4FIw((parcelRequire("iDur4")));

var $bf6d63841b1b6f50$var$_querySelectorAll = $l4FIw((parcelRequire("2XHph")));
var $bf6d63841b1b6f50$var$matchesCache;
function $bf6d63841b1b6f50$var$matches(node, selector) {
    if (!$bf6d63841b1b6f50$var$matchesCache && $bf6d63841b1b6f50$var$_inDOM.default) {
        var body = document.body;
        var nativeMatch = body.matches || body.matchesSelector || body.webkitMatchesSelector || body.mozMatchesSelector || body.msMatchesSelector;
        $bf6d63841b1b6f50$var$matchesCache = nativeMatch ? function(node, selector) {
            return nativeMatch.call(node, selector);
        } : $bf6d63841b1b6f50$var$ie8MatchesSelector;
    }
    return $bf6d63841b1b6f50$var$matchesCache ? $bf6d63841b1b6f50$var$matchesCache(node, selector) : null;
}
function $bf6d63841b1b6f50$var$ie8MatchesSelector(node, selector) {
    var matches = (0, $bf6d63841b1b6f50$var$_querySelectorAll.default)(node.document || node.ownerDocument, selector), i = 0;
    while(matches[i] && matches[i] !== node)i++;
    return !!matches[i];
}
module.exports = module.exports["default"];

});
parcelRegister("2XHph", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $2282c320d9e5bd7b$var$qsa;
// Zepto.js
// (c) 2010-2015 Thomas Fuchs
// Zepto.js may be freely distributed under the MIT license.
var $2282c320d9e5bd7b$var$simpleSelectorRE = /^[\w-]*$/;
var $2282c320d9e5bd7b$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $2282c320d9e5bd7b$var$qsa(element, selector) {
    var maybeID = selector[0] === "#", maybeClass = selector[0] === ".", nameOnly = maybeID || maybeClass ? selector.slice(1) : selector, isSimple = $2282c320d9e5bd7b$var$simpleSelectorRE.test(nameOnly), found;
    if (isSimple) {
        if (maybeID) {
            element = element.getElementById ? element : document;
            return (found = element.getElementById(nameOnly)) ? [
                found
            ] : [];
        }
        if (element.getElementsByClassName && maybeClass) return $2282c320d9e5bd7b$var$toArray(element.getElementsByClassName(nameOnly));
        return $2282c320d9e5bd7b$var$toArray(element.getElementsByTagName(selector));
    }
    return $2282c320d9e5bd7b$var$toArray(element.querySelectorAll(selector));
}
module.exports = module.exports["default"];

});



parcelRegister("e0JA4", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $a3346c28093e523c$var$_classCallCheck2 = $l4FIw((parcelRequire("amPRp")));

var $a3346c28093e523c$var$_createClass2 = $l4FIw((parcelRequire("5pBBk")));

var $a3346c28093e523c$var$_possibleConstructorReturn2 = $l4FIw((parcelRequire("35on9")));

var $a3346c28093e523c$var$_getPrototypeOf3 = $l4FIw((parcelRequire("8yP2g")));

var $a3346c28093e523c$var$_assertThisInitialized2 = $l4FIw((parcelRequire("i4RG1")));

var $a3346c28093e523c$var$_inherits2 = $l4FIw((parcelRequire("eGfZt")));

var $a3346c28093e523c$var$_defineProperty2 = $l4FIw((parcelRequire("jIgr0")));

var $a3346c28093e523c$var$_ModalManager2 = $l4FIw((parcelRequire("3vuoS")));
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/ // needed for the modal manager class
var $a3346c28093e523c$var$SpectrumModalManager = /*#__PURE__*/ function(_ModalManager) {
    (0, $a3346c28093e523c$var$_inherits2["default"])(SpectrumModalManager, _ModalManager);
    function SpectrumModalManager() {
        var _getPrototypeOf2;
        var _this;
        (0, $a3346c28093e523c$var$_classCallCheck2["default"])(this, SpectrumModalManager);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, $a3346c28093e523c$var$_possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, $a3346c28093e523c$var$_getPrototypeOf3["default"])(SpectrumModalManager)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        (0, $a3346c28093e523c$var$_defineProperty2["default"])((0, $a3346c28093e523c$var$_assertThisInitialized2["default"])(_this), "overflowMap", new Map());
        (0, $a3346c28093e523c$var$_defineProperty2["default"])((0, $a3346c28093e523c$var$_assertThisInitialized2["default"])(_this), "superAdd", _this.add);
        (0, $a3346c28093e523c$var$_defineProperty2["default"])((0, $a3346c28093e523c$var$_assertThisInitialized2["default"])(_this), "superRemove", _this.remove);
        (0, $a3346c28093e523c$var$_defineProperty2["default"])((0, $a3346c28093e523c$var$_assertThisInitialized2["default"])(_this), "add", function(modal, container, className, isOverlay) {
            _this.superAdd(modal, container, className);
            _this.hideBodyOverflow(modal, isOverlay);
        });
        (0, $a3346c28093e523c$var$_defineProperty2["default"])((0, $a3346c28093e523c$var$_assertThisInitialized2["default"])(_this), "hideBodyOverflow", function(modal, isOverlay) {
            var currentBodyOverflow = getComputedStyle(document.body).overflow; // if it's not an overlay, it's a modal and scrolling should be disabled (i know, it's weird to think about)
            if (!isOverlay && currentBodyOverflow !== "hidden") {
                _this.overflowMap.set(modal, currentBodyOverflow);
                document.body.style.overflow = "hidden";
            }
        });
        (0, $a3346c28093e523c$var$_defineProperty2["default"])((0, $a3346c28093e523c$var$_assertThisInitialized2["default"])(_this), "remove", function(modal, container, className) {
            _this.superRemove(modal, container, className);
            _this.resetBodyOverflow(modal);
        });
        (0, $a3346c28093e523c$var$_defineProperty2["default"])((0, $a3346c28093e523c$var$_assertThisInitialized2["default"])(_this), "resetBodyOverflow", function(modal) {
            if (_this.overflowMap.has(modal)) {
                document.body.style.overflow = _this.overflowMap.get(modal);
                _this.overflowMap["delete"](modal);
            }
        });
        return _this;
    }
    (0, $a3346c28093e523c$var$_createClass2["default"])(SpectrumModalManager, [
        {
            key: "addToModal",
            value: function addToModal(child) {
                var isOverlay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var hideSiblingNodes = this.hideSiblingNodes;
                this.hideSiblingNodes = false;
                this.add(child, document.body, null, isOverlay);
                this.hideSiblingNodes = hideSiblingNodes;
            }
        },
        {
            key: "removeFromModal",
            value: function removeFromModal(child) {
                var hideSiblingNodes = this.hideSiblingNodes;
                this.hideSiblingNodes = false;
                this.remove(child);
                this.hideSiblingNodes = hideSiblingNodes;
            }
        }
    ]);
    return SpectrumModalManager;
}($a3346c28093e523c$var$_ModalManager2["default"]);
module.exports["default"] = $a3346c28093e523c$var$SpectrumModalManager;

});

parcelRegister("cviGh", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $91a6dee92654e0d3$var$OpenTransition;

var $91a6dee92654e0d3$var$_extends2 = $l4FIw((parcelRequire("5WrMC")));

var $91a6dee92654e0d3$var$_react = $l4FIw((parcelRequire("7eprg")));

var $91a6dee92654e0d3$var$_Transition = $l4FIw((parcelRequire("dd1EO")));
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/ var $91a6dee92654e0d3$var$OPEN_STATES = {
    entering: false,
    entered: true
};
/**
 * timeout issues adding css animations to enter may be related to
 * https://github.com/reactjs/react-transition-group/issues/189 or
 * https://github.com/reactjs/react-transition-group/issues/22
 * my VM isn't good enough to debug accurately and get a better answer
 *
 * as a result, use enter 0 so that is-open is applied once entered
 * it doesn't matter if we know when the css-animation is done on entering
 * for exiting though, give time for the css-animation to play
 * before removing from the DOM
 * **note** hitting esc bypasses exit animation for anyone testing
 */ function $91a6dee92654e0d3$var$OpenTransition(props) {
    return $91a6dee92654e0d3$var$_react["default"].createElement($91a6dee92654e0d3$var$_Transition["default"], (0, $91a6dee92654e0d3$var$_extends2["default"])({
        timeout: {
            enter: 0,
            exit: 125
        }
    }, props), function(state) {
        return $91a6dee92654e0d3$var$_react["default"].cloneElement(props.children, {
            open: !!$91a6dee92654e0d3$var$OPEN_STATES[state]
        });
    });
}

});

parcelRegister("geIu6", function(module, exports) {
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/ 
module.exports = (parcelRequire("dD0wN"));

});
parcelRegister("dD0wN", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $9ebf53b2ec07689a$var$_classCallCheck2 = $l4FIw((parcelRequire("amPRp")));

var $9ebf53b2ec07689a$var$_createClass2 = $l4FIw((parcelRequire("5pBBk")));

var $9ebf53b2ec07689a$var$_react = $l4FIw((parcelRequire("7eprg")));

var $9ebf53b2ec07689a$var$_reactDom = $l4FIw((parcelRequire("5hg2n")));
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/ var $9ebf53b2ec07689a$var$children = {};
/*
 * A global portal that lives in the document body which can be used to add
 * overlays like modals outside the normal React component tree.
 */ var $9ebf53b2ec07689a$var$PortalContainer = /*#__PURE__*/ function() {
    function PortalContainer() {
        (0, $9ebf53b2ec07689a$var$_classCallCheck2["default"])(this, PortalContainer);
    }
    (0, $9ebf53b2ec07689a$var$_createClass2["default"])(PortalContainer, null, [
        {
            key: "add",
            /**
     * Renders the child
     * @param child component to be render
     * @param context Parent with the context
     */ value: function add(child, context) {
                var node = $9ebf53b2ec07689a$var$children[child.key] || document.createElement("div");
                if (!context) $9ebf53b2ec07689a$var$_reactDom["default"].render(child, node);
                else $9ebf53b2ec07689a$var$_reactDom["default"].unstable_renderSubtreeIntoContainer(context, child, node);
                $9ebf53b2ec07689a$var$children[child.key] = node;
            }
        },
        {
            key: "remove",
            value: function remove(child) {
                $9ebf53b2ec07689a$var$_reactDom["default"].unmountComponentAtNode($9ebf53b2ec07689a$var$children[child.key]);
                delete $9ebf53b2ec07689a$var$children[child.key];
            }
        },
        {
            key: "removeAll",
            value: function removeAll() {
                for(var child in $9ebf53b2ec07689a$var$children){
                    // skip loop if the property is from prototype
                    if (!$9ebf53b2ec07689a$var$children.hasOwnProperty(child)) continue;
                    $9ebf53b2ec07689a$var$_reactDom["default"].unmountComponentAtNode($9ebf53b2ec07689a$var$children[child]);
                    delete $9ebf53b2ec07689a$var$children[child];
                }
            }
        }
    ]);
    return PortalContainer;
}();
module.exports["default"] = $9ebf53b2ec07689a$var$PortalContainer;

});




//# sourceMappingURL=js-deferred.e39822af.js.map
